import axios from "axios";
import { Message, Loading } from "element-ui";
import store from "@/store";
var isPro = process.env.NODE_ENV === "production";
var baseURL = isPro ? "" : "";
var processRequest = process.env.VUE_APP_BASE_API;

let loading = null;
let requestCount = 0;

function showLoading() {
  if (!loading) {
    const loadingTarget = document.querySelector(".loading");
    if (loadingTarget) {
      loading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "var(--request-Background)",
        customClass: "request-loading",
        target: loadingTarget, // 指定加载目标
      });
    }
  }
}

function hideLoading() {
  if (loading) {
    loading.close();
    loading = null;
  }
}

const service = axios.create({
  baseURL: processRequest,
  // timeout: 10000,
});

service.interceptors.request.use(
  (config) => {
    if (requestCount === 0 && requestCount < 1) {
      console.log(requestCount);
      showLoading();
    }
    requestCount++;

    if (!config.headers["Content-Type"]) {
      // 其他请求头处理逻辑...
    }

    const token = localStorage.getItem("Authorization") || "";
    const tenantId = localStorage.getItem("tenantId") || "";

    if (token) {
      config.headers["Authorization"] = token;
      config.headers["Authorization"] = token;
      if (tenantId) {
        config.headers["tenantId"] = tenantId;
      }
    } else {
      config.headers["Authorization"] = "";
    }
    // 添加 hostType 请求头
    config.headers["hostType"] = "webTenant";

    store.commit("upBtnLoading", true); //更新a-dialog按钮节流信息

    return config;
  },
  (error) => {
    requestCount--;
    if (requestCount === 0) {
      hideLoading();
    }
    store.commit("upBtnLoading", false); //更新a-dialog按钮节流信息
    console.log("发送失败", error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    requestCount--;
    if (response.data.msg == "登录状态已过期" || (response.data.code == 401 && response.data.msg == "此账号已到期，请联系管理员!")) {
        
      if (requestCount <= 0) {
        // localStorage.clear();//清除全部
        // 清除 localStorage 中的特定项
        const itemsToKeep = [
          "layout-setting",
          "savedUsername",
          "savedPassword",
          "maxkbMaskTip",
        ]; // 需要保留的项
        const keysToRemove = Object.keys(localStorage).filter(
          (key) => !itemsToKeep.includes(key)
        );
        keysToRemove.forEach((key) => localStorage.removeItem(key));
        // localStorage.clear(); //移除所有缓存

        window.location.href = "/";
        Message({
          message: "登录状态已过期，请重新登录！",
          type: "error",
          duration: 3 * 1000,
        });
      }
    }

    if (requestCount === 0) {
      hideLoading();
    }
    store.commit("upBtnLoading", false); //更新a-dialog按钮节流信息
    const dataAxios = response.data;
    return dataAxios;
  },
  (error) => {
    requestCount--;
    console.log(requestCount);
    if (requestCount === 0) {
      hideLoading();
    }
    store.commit("upBtnLoading", false); //更新a-dialog按钮节流信息
    Message({
      message: error,
      type: "error",
      duration: 3 * 1000,
    });

    return Promise.reject(error);
  }
);

const http = {
  post(url, data = {}, headers = {}) {
    return service({
      url: `${url}`,
      method: "post",
      data: data,
      headers,
    });
  },
  delete(url, data) {
    return service({
      method: "delete",
      url: `${url}`,
      data: data,
    });
  },

  put(url, data, headers = {}) {
    return service({
      method: "put",
      url: `${url}`,
      data: data,
      headers,
    });
  },
  get(url, data) {
    return service.get(`${url}`, {
      params: data,
    });
  },
  baseURL,
  processRequest,
};

export default http;
